var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"topheader"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_vm._v("Prêt pour un bébé?")])]),_c('div',{staticClass:"infobutton",on:{"click":_vm.openCloseInfoScreen}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }